import * as orderFileService from 'services/orderFileService';

export async function uploadFiles(
  fileUploads: Array<{ file: File; progress: number; controller: AbortController }>,
  orderId: number,
  onProgress: (percentCompleted: number, i: number) => void
): Promise<void> {
  await Promise.allSettled(
    fileUploads.map(
      async (f, i) =>
        await orderFileService.uploadOrderFileAsync(orderId, f.file, {
          onUploadProgress: (e) => {
            const percentCompleted = Math.round((e.progress ?? 0) * 100);

            onProgress(percentCompleted, i);
          },
          signal: f.controller.signal,
        })
    )
  );
}
